import { Box, Typography } from '@mui/material';
import i18n from '../../../i18n';
import { formatEUR } from '../../../constants/tool.fn';
import DataListItem from './data-list-item';
import { ReactComponent as DineIcon } from '../../../static/images/svg/free_breakfast.svg';
import { ReactComponent as DeliveryIcon } from '../../../static/images/svg/ph_handbag-fill.svg';
import { ReactComponent as MoneyIcon } from '../../../static/images/svg/ri_coins-fill.svg';
import { ReactComponent as PeopleIcon } from '../../../static/images/svg/mdi_account-multiple.svg';

/** 当前营业状态数据结构（后续对接接口时替换为接口类型） */
export type CurrentStatusData = {
    /** 当前总营收（€） */
    totalRevenue: number;
    /** 当前桌台：使用中数量 */
    tableUsed: number;
    /** 当前桌台：总数量 */
    tableTotal: number;
    /** 外卖订单数 */
    takeoutOrderCount: number;
    /** 堂食开桌人数 */
    dineInCustomerCount: number;
    /** 当前堂食人数 */
    currentDineInCustomerCount: number;
};

const LIST_BORDER_STYLE = {
    '& > *:not(:last-child)': {
        borderBottom: '1px solid var(--stroke-neutral-800-a25)',
        paddingBottom: '8px',
        marginBottom: '8px',
    },
    border: '1px solid var(--stroke-neutral-800-a25)',
    padding: '24px 8px',
    borderRadius: '16px',
};

/**
 * 当前营业状态区块
 * 展示：当前总营收、当前桌台数量、外卖订单数、当前堂食人数
 */
export default function CurrentStatusSection(props: Readonly<{ data: CurrentStatusData }>) {
    const { data } = props;
    return (
        <>
            <Typography variant="h4" sx={{ color: 'var(--text-primary-300)', textAlign: 'center' }}>
                {i18n.t('business_analysis_page_current_business_status')}
            </Typography>
            <Box sx={LIST_BORDER_STYLE}>
                <DataListItem
                    icon={<MoneyIcon height="24px" color="var(--icon-neutral-500)" />}
                    title={i18n.t('dashboards_data_current_total_revenue')}
                    num={formatEUR(data.totalRevenue)}
                />
                <DataListItem
                    icon={<DineIcon height="24px" color="var(--icon-neutral-500)" />}
                    title={i18n.t('dashboards_data_current_table_count')}
                    num={`${data.tableUsed}/${data.tableTotal}`}
                />
                <DataListItem
                    icon={<DeliveryIcon height="24px" color="var(--icon-neutral-500)" />}
                    title={i18n.t('business_analysis_page_text_takeaways_orders_nums')}
                    num={String(data.takeoutOrderCount)}
                />
                <DataListItem
                    icon={<PeopleIcon height="24px" color="var(--icon-neutral-500)" />}
                    title={i18n.t('business_analysis_page_text_dine_in_people_nums')}
                    num={String(data.dineInCustomerCount)}
                />
                <DataListItem
                    icon={<PeopleIcon height="24px" color="var(--icon-neutral-500)" />}
                    title={i18n.t('dashboards_data_current_dine_in_customer_count')}
                    num={String(data.currentDineInCustomerCount)}
                />
            </Box>
        </>
    );
}
